export default __webpack_public_path__ + "static/media/phone.fcfce733.png";